import comp from "./AITutorV2";
export default comp;
